// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2F2ND","consentsList":"PatientConsents_consentsList__1T_VH","consentsListEmpty":"PatientConsents_consentsListEmpty__3b1Q2"};